import { useLazyQuery, useQuery } from "@apollo/client";
import {
  AutoFillData,
  GET_AUTOFILL_QUERY,
  GET_WEBPAGE_QUERY,
  WebpageData,
} from "../../../api/Requests";
import { SimpleData } from "../../../components/Webpage/SimpleData";
import { MyLittleLoader } from "../../../util/myLoader";
import "./WebpageDataView.css";
import { TbSparkles } from "react-icons/tb";
import { useState } from "react";

export default function WebpageDataView() {
  const {
    loading: queryLoading,
    error: queryError,
    data: queryData,
  } = useQuery<WebpageData>(GET_WEBPAGE_QUERY, {
    variables: {
      version: 1,
    },
  });

  const [autoFillQuery] = useLazyQuery<AutoFillData>(GET_AUTOFILL_QUERY);
  const [autoFillData, setAutoFillData] = useState<string | undefined>();

  function fetchAutoFillData() {
    autoFillQuery({
      variables: {
        industry: "Webpage Creation",
      },
      fetchPolicy: "cache-and-network",
    })
      .then(response => {
        setAutoFillData(
          response.data?.autoFill?.aiChoices?.[0].message?.content,
        );
      })
      .catch(error => console.error("AutoFill Error: ", error));
  }

  return (
    <div id="webpageDataView" className="pageContainer">
      <h1>Your Info</h1>
      {/*
      <button className="altButton" onClick={fetchAutoFillData}>
        <TbSparkles /> Generate Webpage Info
      </button>
      {autoFillData}
      */}
      <div className="pageItem">
        <p>This data will be used to personalize your webpage.</p>
        {queryLoading && <MyLittleLoader />}
        {queryData?.webpage && !queryLoading && !queryError && (
          <SimpleData inputData={queryData.webpage} />
        )}
      </div>
    </div>
  );
}
